import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import { actions as LKModalActions } from 'shared/LKModal'
import { clientRatingModal } from './constants'

export const open = (ID, hash, fullname) => LKModalActions.open({ name: clientRatingModal, ID, hash, fullname })

export default Loadable(() => import('./ClientRatingModal'))
